<script lang="ts">
  import { getContext } from "svelte";
  import { ConnectMapApp } from "../app";
  import PoiDetail from "./PoiDetail.svelte";
  import PoiList from "./PoiList.svelte";
  import RouteSetup from "./RouteSetup.svelte";
  import InfoPane from "../InfoPane.svelte";
  import TopBar from "../TopBar.svelte";
  import Navigation from "./Navigation.svelte";

  const app = getContext<ConnectMapApp<any>>('app');
  
  const { state, is_desktop } = app;

  let poi_list: any;

  function keyEvent (event: KeyboardEvent) {
    poi_list?.keyEvent && poi_list.keyEvent(event);
  }

  function focusTopbar () {
    app.state.showListing();
  }
</script>


<div class="pane">
  <TopBar on:keyup={keyEvent} on:focus={focusTopbar} />
  {#if $state == 'map_view' || $state == 'list_view'}
  <div class="list">
    <PoiList bind:this={poi_list} />
  </div>
  {:else if $state == 'detail_view'}
    <PoiDetail />
  {:else if $state == 'route_setup_view'}
    <RouteSetup />
  {:else if $state == 'navigation_view' && $is_desktop}
    <Navigation />
  {:else if $state == 'info_view'}
    <InfoPane />
  {/if}
</div>

<style>
  .pane {
    width: 100%;
    height: 100%;
    padding: var(--_p1);
    background-color: var(--_bg-1st);
  }

  .list {
    position: relative;
    top: calc(50px);
    height: 100%;
    margin: 0 calc(var(--vgwv-p8) + 1px); /* using shadow so compensate w/ width */
    box-sizing: border-box;
    overflow-y: scroll;
    box-shadow: 0 1px 1px rgba(0,0,0,.25);
    transition: height .2s, padding .3s;

    @media (min-width: 768px) {
      top: unset;
    }
  }

  .vgwv-search-results--expanded {
    height: 78%; /* For IE11 */
    height: calc(100% - 50px - var(--vgwv-p16));
    padding-top: var(--vgwv-p24);
    transition: height .3s .2s ease, padding .3s .2s ease;
  }

</style>
